import { cn } from "../lib/utils";
import type { FC, HTMLAttributes } from "react";

type ImageBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  borderStyle?: "hard" | "soft";
};

const ImageBadge: FC<ImageBadgeProps> = ({
  borderStyle = "hard",
  className,
  children,
  ...props
}) => (
  <span
    className={cn(
      "!bb-text-nano h-[1.625rem] text-white uppercase",
      "absolute top-0 left-0 flex items-center justify-center",
      "bg-rusty-brown px-2",
      { "rounded-sm": borderStyle === "soft" },
      className,
    )}
    {...props}
  >
    {children}
  </span>
);
ImageBadge.displayName = "ImageBadge";

export { ImageBadge };
